/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DealLableOrderItem = ({ product, currency, dealData }: any) => {
	// const [text, setText]: any = useState('');
	const { t } = useTranslation();
	const text = useMemo(() => {
		if (dealData?.deal_type === 'BULK_PRICING') {
			return t(dealData?.deal_type.toLowerCase());
		}
		if (dealData?.deal_type === 'BUY_X_AND_GET_Y') {
			return (
				dealData?.buy_product +
				'+' +
				dealData?.free_product
			);
		}

		if (dealData?.deal_type === 'DISCOUNT') {
			if (currency) {
				let string = '';
				if (dealData?.discount_type === 'PERCENT') {
					string += dealData?.percent + '%';
				} else {
					string = `${dealData?.amount} ${currency}`;
				}
				string += ' Off ';
				return string;
			}
		}
	}, [currency, product]);
	return (
		<span
			className='badge badge-info ms-2'
			style={{
				borderRadius: '20px',
				color: '#fff',
				backgroundColor:
					dealData?.deal_type === 'BUY_X_AND_GET_Y'
						? '#FEA800'
						: dealData?.deal_type === 'DISCOUNT'
						? '#F18137'
						: '#7239EA'
			}}
		>
			{text}
		</span>
	);
};
